
export const authTranslations = {
  en: {
    "auth.title": "Authentication",
    "auth.login.title": "Login",
    "auth.login.description": "Welcome back! Please enter your credentials.",
    "auth.login.emailLabel": "Email",
    "auth.login.emailPlaceholder": "Enter your email",
    "auth.login.passwordLabel": "Password",
    "auth.login.passwordPlaceholder": "Enter your password",
    "auth.login.loginButton": "Login",
    "auth.login.noAccount": "Don't have an account?",
    "auth.login.signupLink": "Sign up",
    "auth.login.requiredForDownload": "You need to be logged in to download this content",
    
    "auth.signup.title": "Create Account",
    "auth.signup.description": "Join our community by creating an account.",
    "auth.signup.emailLabel": "Email",
    "auth.signup.emailPlaceholder": "Enter your email",
    "auth.signup.passwordLabel": "Password",
    "auth.signup.passwordPlaceholder": "Create a strong password",
    "auth.signup.confirmPasswordLabel": "Confirm Password",
    "auth.signup.confirmPasswordPlaceholder": "Confirm your password",
    "auth.signup.signupButton": "Sign up",
    "auth.signup.haveAccount": "Already have an account?",
    "auth.signup.loginLink": "Login",
    
    "auth.forgotPassword.title": "Forgot Password",
    "auth.forgotPassword.description": "Enter your email and we'll send you a reset link.",
    "auth.forgotPassword.emailLabel": "Email",
    "auth.forgotPassword.emailPlaceholder": "Enter your email",
    "auth.forgotPassword.resetButton": "Send Reset Link",
    "auth.forgotPassword.backToLogin": "Back to login",
    
    "auth.resetPassword.title": "Reset Password",
    "auth.resetPassword.description": "Enter your new password below.",
    "auth.resetPassword.passwordLabel": "New Password",
    "auth.resetPassword.passwordPlaceholder": "Enter new password",
    "auth.resetPassword.confirmPasswordLabel": "Confirm Password",
    "auth.resetPassword.confirmPasswordPlaceholder": "Confirm new password",
    "auth.resetPassword.resetButton": "Reset Password",
    "auth.resetPassword.backToLogin": "Back to login",
    
    "auth.logout": "Logout",
    "auth.profile": "Profile",
    
    "auth.validation.emailRequired": "Email is required",
    "auth.validation.validEmail": "Please enter a valid email",
    "auth.validation.passwordRequired": "Password is required",
    "auth.validation.passwordMinLength": "Password must be at least 6 characters",
    "auth.validation.passwordsDoNotMatch": "Passwords do not match",
    "auth.validation.confirmPassword": "Please confirm your password",
    
    "auth.error.generic": "Authentication error",
    "auth.error.invalidCredentials": "Invalid email or password",
    "auth.error.emailInUse": "Email already in use",
    "auth.error.weakPassword": "Password is too weak",
    "auth.error.userNotFound": "User not found",
    "auth.error.resetLinkExpired": "Reset link has expired"
  },
  fr: {
    "auth.title": "Authentification",
    "auth.login.title": "Connexion",
    "auth.login.description": "Bienvenue ! Veuillez saisir vos identifiants.",
    "auth.login.emailLabel": "Email",
    "auth.login.emailPlaceholder": "Entrez votre email",
    "auth.login.passwordLabel": "Mot de passe",
    "auth.login.passwordPlaceholder": "Entrez votre mot de passe",
    "auth.login.loginButton": "Se connecter",
    "auth.login.noAccount": "Vous n'avez pas de compte ?",
    "auth.login.signupLink": "S'inscrire",
    "auth.login.requiredForDownload": "Vous devez être connecté pour télécharger ce contenu",
    
    "auth.signup.title": "Créer un compte",
    "auth.signup.description": "Rejoignez notre communauté en créant un compte.",
    "auth.signup.emailLabel": "Email",
    "auth.signup.emailPlaceholder": "Entrez votre email",
    "auth.signup.passwordLabel": "Mot de passe",
    "auth.signup.passwordPlaceholder": "Créez un mot de passe fort",
    "auth.signup.confirmPasswordLabel": "Confirmer le mot de passe",
    "auth.signup.confirmPasswordPlaceholder": "Confirmez votre mot de passe",
    "auth.signup.signupButton": "S'inscrire",
    "auth.signup.haveAccount": "Vous avez déjà un compte ?",
    "auth.signup.loginLink": "Se connecter",
    
    "auth.forgotPassword.title": "Mot de passe oublié",
    "auth.forgotPassword.description": "Entrez votre email et nous vous enverrons un lien de réinitialisation.",
    "auth.forgotPassword.emailLabel": "Email",
    "auth.forgotPassword.emailPlaceholder": "Entrez votre email",
    "auth.forgotPassword.resetButton": "Envoyer le lien",
    "auth.forgotPassword.backToLogin": "Retour à la connexion",
    
    "auth.resetPassword.title": "Réinitialiser le mot de passe",
    "auth.resetPassword.description": "Entrez votre nouveau mot de passe ci-dessous.",
    "auth.resetPassword.passwordLabel": "Nouveau mot de passe",
    "auth.resetPassword.passwordPlaceholder": "Entrez le nouveau mot de passe",
    "auth.resetPassword.confirmPasswordLabel": "Confirmer le mot de passe",
    "auth.resetPassword.confirmPasswordPlaceholder": "Confirmez le nouveau mot de passe",
    "auth.resetPassword.resetButton": "Réinitialiser le mot de passe",
    "auth.resetPassword.backToLogin": "Retour à la connexion",
    
    "auth.logout": "Déconnexion",
    "auth.profile": "Profil",
    
    "auth.validation.emailRequired": "L'email est requis",
    "auth.validation.validEmail": "Veuillez entrer un email valide",
    "auth.validation.passwordRequired": "Le mot de passe est requis",
    "auth.validation.passwordMinLength": "Le mot de passe doit comporter au moins 6 caractères",
    "auth.validation.passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "auth.validation.confirmPassword": "Veuillez confirmer votre mot de passe",
    
    "auth.error.generic": "Erreur d'authentification",
    "auth.error.invalidCredentials": "Email ou mot de passe invalide",
    "auth.error.emailInUse": "Email déjà utilisé",
    "auth.error.weakPassword": "Le mot de passe est trop faible",
    "auth.error.userNotFound": "Utilisateur non trouvé",
    "auth.error.resetLinkExpired": "Le lien de réinitialisation a expiré"
  }
};

export type AuthTranslationKey = keyof typeof authTranslations.en;
